import { fetchGET, fetchPUT } from "../utils/handler_http";

export const getAppStatus = async () => {
  return await fetchGET(process.env.REACT_APP_APP_STATUS_ENDPOINT, {}, {});
};

export const updateAppStatus = async (payload = {}, jwt = "") => {
  return await fetchPUT(
    process.env.REACT_APP_APP_STATUS_ENDPOINT,
    payload,
    { Authorization: jwt },
  );
};
